import ApiDefinition from "./ApiDefinition";


const AIApi = new ApiDefinition({
    chat: {
        url: () => `mcp/uwe`,
        method: 'post',
        body: data => data
    },
})

export default AIApi;
